<template>
    <div class="team-page">
        <div class="top-menu">
            <div class="top">人工智能与机器视觉实验室</div>
            <div class="blank"></div>
            <div class="menu">
                <div class="menu-detail" @click="jumpToHome">首页</div>
                <div class="menu-detail" @click="jumpToTutor">导师风采</div>
                <div class="menu-detail" @click="jumpToTeam">科研团队</div>
                <div class="menu-detail" @click="jumpToPaper">论文成果</div>
                <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
                <div class="menu-detail" @click="jumpToDownload">文件下载</div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contribution </div>
            </div>
        </div>
        <div class="blank"></div>
        <div class="page-content">
            <div class="paper-block">
                <div class="paper-block-title">获奖情况</div>
                <div class="paper-block-word">
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        孙瑞 2023年硕士研究生<b>国家奖学金</b>
                            </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        王日升 2021年硕士研究生<b>国家奖学金</b>
                            </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        李林泽 2021年硕士研究生<b>国家奖学金</b>
                            </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        张宇啸 2021年陕西科技大学硕士研究生<b>优秀毕业论文</b>
                            </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        张宇啸 2020年硕士研究生<b>国家奖学金</b>
                            </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        加小红 2019年博士研究生<b>国家奖学金</b>
                            </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        薛丁华 2018年硕士研究生<b>国家奖学金</b>
                    </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        孙瑞 2021年陕西科技大学本科优秀毕业设计一等奖
                    </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        马熙琛 2021年陕西科技大学本科优秀毕业设计一等奖
                    </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        张宇啸 IEEE FG2018 HoMGR 手势识别全球挑战赛 亚军
                    </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        李云彤 陕西省第十一届自动化专业本科优秀毕业设计大赛一等奖
                    </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        张 肖  陕西省第十届自动化专业本科优秀毕业设计大赛二等奖
                    </div>
                    <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        尚佳童 2020年陕西科技大学本科优秀毕业设计二等奖
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>
    </div>
</template>

<script>
    export default {
        methods: {
            jumpToHome() {
                this.$router.push({
                    name: "home",
                });
            },
            jumpToTutor() {
                this.$router.push({
                    name: "tutor",
                });
            },
            jumpToTeam() {
                this.$router.push({
                    name: "team",
                });
            },
            jumpToPaper() {
                this.$router.push({
                    name: "paper",
                });
            },
            jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
            jumpToDownload() {
                this.$router.push({
                    name: "download",
                });
            },
            jumpToInnovation() {
                this.$router.push({
                    name: "innovation",
                });
            },
            jumpToService() {
                this.$router.push({
                    name: "service",
                });
            },
            jumpToInfluence_Contribution() {
                this.$router.push({
                    name: "influence_contribution",
                });
            },
        },
    };
</script>

<style scoped>
    .team-page {
        width: 100%;
        height: 100%;
        background-color: #fffef9;
        display: flex;
        flex-direction: column;
    }

    .top-menu {
        width: 100%;
    }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }

  .blank {
    background-color: #dfe8ed;
    height: 3px;
    width: 100%;
  }


    .menu-detail:hover {
        background-color: #dfe8ed;
    }

    .page-content {
        width: 100%;
    }

    .paper-block {
        border: 1px solid #517b95;
        margin: 10px 100px;
    }

    .paper-block-title {
        background-color: #7494b1;
        color: #ffffff;
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        padding-left: 20px;
        letter-spacing: 3px;
    }

    .paper-block-word {
        line-height: 28px;
        padding-left: 20px;
        font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
        font-size: 18px;
    }

    .paper-block-word-item {
        padding-bottom: 10px;
    }

    .icon-yuandianzhong {
        color: #8a9098;
    }
    .footer{
        height: 70px;
        background-color:#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
        width: 100%;
        position: fixed;
        bottom: 0;
    }
</style>>